window.cartType = 'mini-cart';
/* After Customall adds to cart via its own AJAX, open the theme's Memorelo
   <cart-drawer>. SlideCartHQ is NOT installed here, so the old
   window.SLIDECART_UPDATE() call threw (undefined) and nothing opened — the
   item went into the cart but no drawer appeared. Fetches fresh cart-drawer +
   cart-icon-bubble section HTML from the CART url (not the homepage, which is
   edge-cached and returns HTML, breaking .json()) and hands it to Dawn's
   CartDrawer.renderContents (refreshes line items + opens). */
window.addToCartCallback = (cart) => {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) {
    /* No drawer (cart_type not 'drawer'?) — fall back to SlideCart only if it
       happens to be installed; never throw on an undefined SlideCart. */
    if (typeof window.SLIDECART_OPEN === 'function') {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE(cart);
      window.SLIDECART_OPEN();
    }
    return;
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || (root.replace(/\/$/, '') + '/cart');
  fetch(cartUrl + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (sections) {
      if (sections && sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id: (cart && cart.id) || null, sections: sections });
      } else if (typeof drawer.open === 'function') {
        drawer.open();
      }
    })
    .catch(function () {
      if (typeof drawer.open === 'function') drawer.open();
    });
};

/* Gallery swap on Customall products.
   - Initial: Customall live preview shown (#artwork-preview), theme
     main slider hidden by CSS default. Thumbnails always visible.
   - User clicks a thumbnail: show theme main slider (so the chosen
     product photo is visible), hide Customall preview.
   - User clicks/changes a personalisation control: swap back to
     Customall preview, hide theme main. */
(function () {
  var LOG = '[gallery-swap]';
  var wired = false;

  function getEls() {
    return {
      preview: document.querySelector('#artwork-preview'),
      mainSlider: document.querySelector(
        '.product__media-wrapper media-gallery slider-component[id^="GalleryViewer"]'
      ),
      thumbs: document.querySelector(
        '.product__media-wrapper media-gallery slider-component[id^="GalleryThumbnails"]'
      ),
      personalization: document.querySelector('.ctm-customize-product'),
    };
  }

  function showCustomallPreview() {
    var els = getEls();
    if (els.preview) els.preview.classList.remove('customall-preview-hidden');
    if (els.mainSlider) els.mainSlider.classList.remove('theme-main-shown');
  }

  function showThemeMain() {
    var els = getEls();
    if (els.preview) els.preview.classList.add('customall-preview-hidden');
    if (els.mainSlider) els.mainSlider.classList.add('theme-main-shown');
  }

  function wire() {
    if (wired) return;
    var els = getEls();
    if (!els.preview || !els.mainSlider || !els.thumbs || !els.personalization) return;
    wired = true;

    /* Thumbnail click → show theme main image (with chosen slide). */
    els.thumbs.addEventListener('click', showThemeMain, { capture: true });

    /* Personalisation interaction → show Customall live preview. */
    ['click', 'change', 'input'].forEach(function (evt) {
      els.personalization.addEventListener(evt, showCustomallPreview, { capture: true });
    });

    /* Default state: Customall preview visible (CSS handles this). */
    showCustomallPreview();
    console.log(LOG, 'wired: thumb→theme, personalisation→preview');
  }

  function init() {
    wire();
    if (wired) return;
    var observer = new MutationObserver(wire);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* The dnart-only "price-lev-restorer" IIFE (EUR → BGN lev suffix) lived
   here. Eugiftstore is a Romanian market that bills in EUR only, so the
   dual-currency display is intentionally removed. The Customily side was
   cleaned up the same way earlier; keep both apps consistent. */

/* Two tweaks for Customall product pages:
   1. Move .cart-qty (Customall's quantity dropdown) ABOVE .ctm-customize-product
      so it matches the Customily layout (qty before personalization options).
   2. Replace the raw <select> inside .cart-qty with a +/− stepper UI that
      drives the underlying select via change events — Customall keeps reading
      its own form, but the user sees a stepper matching the Dawn theme look. */
(function () {
  var LOG = '[customall-fixes]';
  var QUANTITY_SELECTOR = '.cart-qty';
  var CARD_SELECTOR = '.ctm-customize-product';

  var attempts = 0;
  var loggedOnce = false;

  function moveQuantityAboveCard() {
    var quantity = document.querySelector(QUANTITY_SELECTOR);
    var card = document.querySelector(CARD_SELECTOR);
    if (!quantity || !card) return false;
    if (card.previousElementSibling === quantity) return true;
    try {
      card.parentNode.insertBefore(quantity, card);
      console.log(LOG, 'moved .cart-qty before card');
      return true;
    } catch (e) {
      console.error(LOG, 'move failed:', e);
      return false;
    }
  }

  function injectStepper() {
    var cartQty = document.querySelector('.cart-qty');
    if (!cartQty) return;
    var select = cartQty.querySelector('select.form-select, select');
    if (!select) return;
    /* Already injected? (re-renders may remove our stepper — re-inject below.) */
    if (cartQty.querySelector('.cart-qty-stepper')) return;

    var stepper = document.createElement('div');
    stepper.className = 'cart-qty-stepper';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'cart-qty-stepper__btn cart-qty-stepper__btn--minus';
    minus.setAttribute('aria-label', 'Намали количество');
    minus.innerHTML = '<svg viewBox="0 0 10 2" width="10" height="2" aria-hidden="true"><rect width="10" height="2" rx="1" fill="currentColor"/></svg>';

    var valueEl = document.createElement('span');
    valueEl.className = 'cart-qty-stepper__value';

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'cart-qty-stepper__btn cart-qty-stepper__btn--plus';
    plus.setAttribute('aria-label', 'Увеличи количество');
    plus.innerHTML = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><rect x="4" width="2" height="10" rx="1" fill="currentColor"/><rect y="4" width="10" height="2" rx="1" fill="currentColor"/></svg>';

    stepper.appendChild(minus);
    stepper.appendChild(valueEl);
    stepper.appendChild(plus);
    cartQty.appendChild(stepper);

    function refresh() {
      var opt = select.options[select.selectedIndex];
      valueEl.textContent = opt ? (opt.textContent || '').trim() : '1';
      minus.disabled = select.selectedIndex <= 0;
      plus.disabled = select.selectedIndex >= select.options.length - 1;
    }

    function changeBy(delta) {
      var newIdx = select.selectedIndex + delta;
      if (newIdx < 0 || newIdx >= select.options.length) return;
      select.selectedIndex = newIdx;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
      refresh();
    }

    minus.addEventListener('click', function () { changeBy(-1); });
    plus.addEventListener('click', function () { changeBy(1); });
    select.addEventListener('change', refresh);
    refresh();
    console.log(LOG, 'stepper injected');
  }

  function tick() {
    attempts++;
    moveQuantityAboveCard();
    injectStepper();

    if (!loggedOnce) {
      var cartQty = document.querySelector('.cart-qty');
      var card = document.querySelector('.ctm-customize-product');
      if (cartQty && card) {
        loggedOnce = true;
        console.log(LOG, 'init complete (cart-qty + card present)');
      }
    }
  }

  function init() {
    console.log(LOG, 'init');
    tick();
    var poll = setInterval(function () {
      tick();
      if (attempts >= 100) {
        clearInterval(poll);
        console.log(LOG, 'poll finished');
      }
    }, 200);

    /* MutationObserver catches late re-renders (variant change, modal close). */
    var observer = new MutationObserver(function () { tick(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Romanian localisation for Customall labels.
   The app ships English labels ("Preview", "Add to cart", "Quantity")
   that aren't translated by the merchant's Customall Translations panel
   for this store. Rather than waiting for Customall's own i18n flow,
   replace the visible text directly. Watches for late re-renders for
   ~60s so variant changes / modal mounts don't revert.

   When new markets land (DE, IT, ES …), swap the `ro` values out for
   that locale or wire this list up to a /locale-derived map. */
(function () {
  var LOG = '[customall-i18n-ro]';
  var TRANSLATIONS = [
    { selector: 'button.btn-preview', en: 'Preview', ro: 'Previzualizează designul' },
    { selector: 'button.btn-add-to-cart', en: 'Add to cart', ro: 'Adăugați în coș' },
    { selector: '.cart-qty > label', en: 'Quantity', ro: 'Cantitate' },
  ];

  function findTextNode(el) {
    /* For non-button elements (e.g. <label>), the text sits directly on
       the element — return it as-is. For buttons with nested spans, pick
       the deepest text-bearing node. */
    if (el.tagName !== 'BUTTON' || el.children.length === 0) return el;
    var candidates = el.querySelectorAll('span, div');
    for (var i = 0; i < candidates.length; i++) {
      var t = (candidates[i].textContent || '').trim();
      if (t && candidates[i].children.length === 0) return candidates[i];
    }
    return el;
  }

  function translateAll() {
    TRANSLATIONS.forEach(function (entry) {
      document.querySelectorAll(entry.selector).forEach(function (el) {
        var target = findTextNode(el);
        var current = (target.textContent || '').trim();
        if (current === entry.ro) return;
        if (current === entry.en || /^(preview|add to cart|quantity)$/i.test(current)) {
          target.textContent = entry.ro;
        }
      });
    });
  }

  function init() {
    translateAll();
    var observer = new MutationObserver(translateAll);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Tag <body> with `cart-open` whenever Dawn's <cart-drawer> is active
   or SlideCartHQ is visible — companion CSS in customall-v2.css then
   hides Customall's #artwork-preview and the product media wrapper so
   they can't paint above the drawer (stacking-context quirks let them
   escape a plain z-index fix). Mirrors the same logic in
   customily-script-v2.js used for non-Customall products. */
(function () {
  function isVisible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function update() {
    var slidecartOpen = isVisible(document.querySelector('.slidecarthq'));
    var dawnCartOpen = !!document.querySelector('cart-drawer.active');
    document.body.classList.toggle('cart-open', slidecartOpen || dawnCartOpen);
  }

  function watch() {
    update();
    var observer = new MutationObserver(update);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
